
module.cC({
    name: 'ProgramModelController',
    inject: ['$scope', 'programModel'],
    data: {programModel: 'programModel'},

    listen: {
        program_model: {
            update: '_updateLog',
        }
    },

    methods: {
        _updateLog: function() {
            this.$scope.log.load();
        }
    }     
});
